<template>
  <div class="flex align-items-center justify-between mb-2 bg-surface-150">
    <!-- Selector de tamaño de página -->
    <div class="flex align-items-center gap-2 mr-3">
      <span>Mostrar: </span>
      <Dropdown
        :value="meta.perPage"
        @change="$emit('pageLimitChange', $event.value)"
        :options="pageSizes"
        optionLabel="label"
        optionValue="value"
        :pageSizes="pageSizes"
        :placeholder="meta.perPage.toString()"
        class="p-dropdown"
      />
    </div>
    <!-- Botones de paginación -->
    <div class="flex align-items-center gap-2">
      <Button
        :disabled="!meta.prev"
        @click="$emit('pageChange', meta.currentPage - 1)"
        label=""
        icon="pi pi-chevron-left"
        class="p-button-rounded p-button-outlined"
      />
      <span>Página {{ meta.currentPage }} de {{ meta.lastPage }}</span>
      <Button
        :disabled="!meta.next"
        @click="$emit('pageChange', meta.currentPage + 1)"
        label=""
        icon="pi pi-chevron-right"
        iconPos="right"
        class="p-button-rounded p-button-outlined"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps<{
    meta: {
      currentPage: number
      perPage: number
      lastPage: number
      next: number | null
      prev: number | null
    }
  }>()

  const pageSizes = [
    { label: '5', value: 5 },
    { label: '10', value: 10 },
    { label: '20', value: 20 },
    { label: '50', value: 50 },
  ]
</script>

<style>
  /* Add any additional styling if needed */
</style>
